import actionClient from '@/api/action'

export default {

  namespaced: true,

  state: {
    token: localStorage.getItem('token') || null,
    currentUser: JSON.parse(localStorage.getItem('user') || 'null') || null,
    roles: []
  },


  mutations: {

    setToken(state, {
      token
    }) {
      state.token = token
      if (token === null) {
        localStorage.removeItem('token')
      } else {
        localStorage.setItem('token', token)
      }
    },

    setCurrentUser(state, {
      user,
      roles = []
    }) {
      state.currentUser = user
      state.roles = roles
      if (user === null) {
        localStorage.removeItem('user')
      } else {
        localStorage.setItem('user', JSON.stringify(user))
      }
    }
  },

  actions: {
    async sendEmailCode({ }, {
      account = ''
    }) {
      if (!account) return
      const data = await actionClient.get(`change-pwd?account=${account}`)
      return data
    },
    async resetPassword({ }, changData) {
      if (!changData.code || !changData.password || !changData.account) return
      const data = await actionClient.post('change-pwd', changData)
      return data
    },
    async login({
      commit
    }, data) {
      const {
        url
      } = await actionClient.post('auth', data)
      if (url) {
        window.location.href = url
      }
    },
    async loginWeChat({
      commit
    }, data) {
      const {
        token
      } = await actionClient.post('login-qrcode', data)
    },

  }


}